  //###################################################################################################
  //#
  //#  (C) 2012-2014 Andriy Borodiychuk, ab@markusweb.com
  //#  http://markusweb.com/
  //#  License: MIT
  //#
  //#  Table controller. Table is received either fully (and then pagination and filtering happens
  //#  on client side), or partially (paginaton and filetrs are processed on server side).
  //#
  //###################################################################################################
  // A helper that is used to generate resources which querying can be cancelled by the next query
  // Use it in a way:
  // .factory('APIEvents', ['Tablify', (Tablify) -> Tablify '/api/private/things/:thing_id/object.json'])
angular.module('mwTable', ['ngCookies', 'ngResource']).factory('Tablify', [
  '$resource',
  '$q',
  function($resource,
  $q) {
    return function(url,
  params = {}) {
      var canceller;
      canceller = $q.defer();
      return function() {
        canceller.resolve();
        canceller = $q.defer();
        return $resource(url,
  params,
  {
          query: {
            method: 'GET',
            timeout: canceller.promise,
            isArray: true
          },
          delete: {
            method: 'DELETE'
          },
          update: {
            method: 'PUT'
          }
        });
      };
    };
  }
]).factory('Table', [
  '$cookies',
  '$filter',
  '$rootScope',
  '$log',
  'smoothScr',
  '$timeout',
  function($cookies,
  $filter,
  $rootScope,
  $log,
  smoothScr,
  $timeout) {
    return function(config) {
      var self;
      self = $rootScope.$new();
      // This object keeps the permanent configuration for your table. These parameters are supposed
      // to be defined during page initialization and not to be changed later.
      self.config = {
        // MANDATORY OPTION. The table name. It has to be unique across your domain, because it is used
        // for storing table settings in cookies
        name: null,
        // MANDATORY OPTION. Type of table. Can be 'full' or 'partial'
        type: null,
        // MANDATORY OPTION. A resource to gt data, ngResource. Must be tablified
        resource: null,
        // Filters. Each filter is named and receives an object that is passed to angular's $filter
        // These filters are applied only to full tables
        filters: {
          all: {}
        },
        // Initial parameters that will be applied on table initialization.
        // Proiroty is config.params > cookies > default params
        params: {},
        // save config in cookies by default
        cookies: true,
        // Classes thay will be used in page header to represent table sorting by specified column
        sortingClasses: {
          asc: '',
          desc: '',
          none: ''
        }
      };
      // This object keeps current parameters, that is selected to table displaying on the webpage.
      // This object is being watched, and when you change it, the table will be rebuilt
      self.params = {
        // Records per page
        limit: 24,
        // Page, starting from 1
        page: 1,
        // Filter
        filter: 'all',
        // Search term, search string
        search: '',
        // Sorting column
        orderby: '',
        // Reverse sorting flag
        reverse: false
      };
      // This is a representation of table data. Use content of this object to display your table
      self.data = {
        // Entries to be display
        display: [],
        // Total amount of entries in table
        total: 0,
        // Total amount of pages
        pages: 0,
        // The number of the first displayed item
        first: 0,
        // The nuber of the last displayed item
        last: 0,
        // Pages to display in pagination
        pagination: []
      };
      //#################################################################################################
      //#
      //#  That's all that may be interesting for table usage. Below is just the module logic
      //#
      //#################################################################################################

      //# Apply passed configuration
      angular.extend(self.config,
  config);
      //# Check configuration and warn
      if (!self.config.name) {
        $log.warn("Table name is not properly set for module mwTable. Table will not work.");
        return self;
      }
      if (['full',
  'partial'].indexOf(self.config.type) === -1) {
        $log.warn("Table type is not properly set for module mwTable. Must be either 'full' or 'partial'. Table will not work.");
        return self;
      }
      if (typeof self.config.resource !== 'function') {
        $log.warn("Table resource is not properly set for module mwTable. Must be a function. Table will not work.");
        return self;
      }
      // Restore table parameters from cookies, if they are there
      if ($cookies.getObject(`t.${self.config.name}`) && self.config.cookies) {
        angular.extend(self.params,
  $cookies.getObject(`t.${self.config.name}`));
      }
      // Apply parameters from config
      angular.extend(self.params,
  self.config.params);
      // This flag shows that table was properly initialized, and blocks the launch of operate()
      // until forst data comes
      self.initialized = false;
      self.table_loading = false;
      // Raw table data is stored here, and being watched for changes
      self.raw = [];
      self.$watch('raw',
  function() {
        return self.operate();
      });
      // Watch table parameters for any change, that will mean table rearrangement for us
      self.$watch('params',
  (function(oldObj,
  newObj) {
        var data,
  forceReload;
        if (angular.equals(oldObj,
  newObj) && self.initialized) {
          return;
        }
        self.table_loading = true;
        // Sometimes we need to reload table, e.g. when we know that data on the server may be changed.
        // Table can be forced to reloaded data from the sorce by passing a dummy attribute to config
        forceReload = false;
        // So if table was force reloaded, then remove that option, called for convenience 'random'
        if (self.params.random != null) {
          delete self.params.random;
          forceReload = true;
        }
        
        // Save new table parameters to cookies
        if (self.config.cookies) {
          $cookies.putObject(`t.${self.config.name}`,
  self.params);
        }
        //console.log self.config.type
        if (self.config.type === 'full') {
          //console.log "2", self.initialized
          self.operate();
          if (forceReload) {
            //console.log "3"
            data = self.config.resource.query(self.params,
  (function() {
              self.initialized = true;
              return self.raw = data;
            }));
          }
        }
        if (self.config.type === 'partial') {
          return data = self.config.resource().query(self.params,
  (function(data,
  headersGetter) {
            self.initialized = true;
            self.data.total = headersGetter('X-Total-Count') || 0;
            return self.raw = data;
          }));
        }
      }),
  true);
      // This method does the filtering and pagination for the full table only
      self.operate = function() {
        var filter_filtered,
  from,
  i,
  len,
  num,
  ordered,
  page,
  pages,
  prev,
  search_filtered,
  to;
        // Avoid run until table is initialized
        if (!self.initialized) {
          return;
        }
        // Format data
        if (self.config.type === 'full') {
          ordered = $filter('orderBy')(self.raw,
  self.params.orderby,
  self.params.reverse);
          filter_filtered = $filter('filter')(ordered,
  self.config.filters[self.params.filter]);
          search_filtered = $filter('filter')(filter_filtered,
  self.params.search);
          self.data.total = search_filtered.length;
          self.data.pages = Math.ceil(search_filtered.length / self.params.limit);
          // Reset page if it is too big or too small
          if (self.params.page > self.data.pages) {
            self.params.page = self.data.pages;
          }
          if (self.params.page < 1) {
            self.params.page = 1;
          }
          // Cut the pie
          self.data.display = search_filtered.splice((self.params.page - 1) * self.params.limit,
  self.params.limit);
        }
        if (self.config.type === 'partial') {
          self.data.pages = Math.ceil(self.data.total / self.params.limit);
          if (self.params.page > self.data.pages) {
            self.params.page = self.data.pages;
          }
          if (self.params.page < 1) {
            self.params.page = 1;
          }
          self.data.display = self.raw;
        }
        // Calculate pagination
        if (self.data.total) {
          // If not empty
          from = (self.params.page - 1) * self.params.limit + 1;
          to = self.params.page * self.params.limit;
          // Maximum should not be more than total
          to = to < self.data.total ? to : self.data.total;
          self.data.first = from;
          self.data.last = to;
        } else {
          self.data.first = 0;
          self.data.last = 0;
        }
        // Visual pagination
        self.pagination = [];
        pages = (function() {
          var i,
  ref,
  results;
          results = [];
          for (num = i = 1, ref = self.data.pages; (1 <= ref ? i <= ref : i >= ref); num = 1 <= ref ? ++i : --i) {
            results.push(num);
          }
          return results;
        })();
        prev = 0;
        for (i = 0, len = pages.length; i < len; i++) {
          page = pages[i];
          if (page < 2 || page > self.data.pages - 2 || (page > self.params.page - 3 && page < self.params.page + 3)) {
            if (prev !== page - 1) {
              self.pagination.push(0);
            }
            self.pagination.push(page);
            prev = page;
          }
        }
        return self.table_loading = false;
      };
      // Set page safely
      self.setPage = function(page) {
        if (page > self.data.pages) {
          return;
        }
        if (page) {
          self.params.page = page;
        }
        return $timeout(function() {
          return smoothScr.scroll('#table',
  0);
        });
      };
      // Set the ordering or reverse automatically
      self.setOrderby = function(orderby) {
        if (self.params.orderby === orderby) {
          return self.params.reverse = !self.params.reverse;
        } else {
          return self.params.orderby = orderby;
        }
      };
      // Classname for the column header that does sorting
      self.headerClass = function(sorting) {
        if (self.params.orderby === sorting && self.params.reverse) {
          return self.config.sortingClasses.desc;
        }
        if (self.params.orderby === sorting && !self.params.reverse) {
          return self.config.sortingClasses.asc;
        }
        return self.config.sortingClasses.none;
      };
      // Force reload table
      self.reload = function(init = false) {
        if (!init) {
          return self.params.random = Math.random();
        }
      };
      // And reload to launch it immediately
      self.reload(self.config.type === 'partial');
      // Return the table
      return self;
    };
  }
]);

// I really hope you enjoyed reading my source code
